import React, { useState,useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { Draggable } from "gsap/Draggable";
import { InertiaPlugin } from "gsap/InertiaPlugin";
import '../white.css';
import Scrollspy from 'react-scrollspy';

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, Draggable, InertiaPlugin);

const Comics = () => {
  const [currentPosition, setCurrentPosition] = useState(1)
  useEffect(() => {
    gsap.registerPlugin(Draggable, InertiaPlugin);

    var slideDelay = 1.5;
    var slideDuration = 0.3;
    var wrap = true;

    var slides = document.querySelectorAll(".slide");
    var prevButton = document.querySelector("#prevButton");
    var nextButton = document.querySelector("#nextButton");
    var progressWrap = gsap.utils.wrap(0, 1);

    var numSlides = slides.length;

    gsap.set(slides, {
      // backgroundColor: "random([red, blue, green, purple, orange, yellow, lime, pink])",
      color: "#000",
      xPercent: i => i * 100
    });

    var wrapX = gsap.utils.wrap(-100, (numSlides - 1) * 100);
    var timer = gsap.delayedCall(slideDelay, autoPlay);

    var animation = gsap.to(slides, {
      xPercent: "+=" + (numSlides * 100),
      duration: 1,
      ease: "none",
      paused: true,
      repeat: -1,
      modifiers: {
        xPercent: wrapX
      }
    });

    var proxy = document.createElement("div");
    var slideAnimation = gsap.to({}, {});
    var slideWidth = 0;
    var wrapWidth = 0;

    var draggable = new Draggable(proxy, {
      trigger: ".slides-container",
      inertia: true,
      onPress: updateDraggable,
      onDrag: updateProgress,
      onThrowUpdate: updateProgress,
      snap: {
        x: snapX
      }
    });

    resize();

    window.addEventListener("resize", resize);

    prevButton.addEventListener("click", function () {
      animateSlides(1);
    });

    nextButton.addEventListener("click", function () {
      animateSlides(-1);
    });

    function updateDraggable() {
      timer.restart(true);
      slideAnimation.kill();
      this.update();
    }


    function animatetoSlide(index) {

      timer.restart(true);
      slideAnimation.kill();
      var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
      console.log(x)
      slideAnimation = gsap.to(proxy, {
        x: x,
        duration: slideDuration,
        onUpdate: updateProgress
      });
    }

    function animateSlides(direction) {
      setCurrentPosition(currentPosition + direction)
      console.log(currentPosition)
      timer.restart(true);
      slideAnimation.kill();
      var x = snapX(gsap.getProperty(proxy, "x") + direction * slideWidth);
      console.log(x)
      slideAnimation = gsap.to(proxy, {
        x: x,
        duration: slideDuration,
        onUpdate: updateProgress
      });
    }

    function autoPlay() {
      if (draggable.isPressed || draggable.isDragging || draggable.isThrowing) {
        timer.restart(true);
      } else {
        // animateSlides(-1);
      }
    }

    function updateProgress() {
      animation.progress(progressWrap(gsap.getProperty(proxy, "x") / wrapWidth));
    }

    function snapX(value) {
      let snapped = gsap.utils.snap(slideWidth, value);
      return wrap ? snapped : gsap.utils.clamp(-slideWidth * (numSlides - 1), 0, snapped);
    }

    function resize() {

      var norm = (gsap.getProperty(proxy, "x") / wrapWidth) || 0;

      slideWidth = slides[0].offsetWidth;
      wrapWidth = slideWidth * numSlides;

      wrap || draggable.applyBounds({ minX: -slideWidth * (numSlides - 1), maxX: 0 });

      gsap.set(proxy, {
        x: norm * wrapWidth
      });

      animateSlides(0);
      slideAnimation.progress(1);
    }

  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>Comics</h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              Comic №5 CRISPR - Cas9
            </div>
            <Scrollspy
              offset={-140}
              className="scrollspy" items={['Comics', 'Characters']}
              currentClassName="active">
              <li><a href="#Comics">Comics</a></li>
              <li><a href="#Characters">Characters</a></li>

              <div>

                <li><a href="#">Episode 1</a></li>
                <li><a href="#">Episode 2</a></li>
                <li><a href="#">Episode 3</a></li>
                <li><a href="#">Episode 4</a></li>
                <li><a href="#">Episode 5</a></li>
                <li><a href="#">Episode 6</a></li>
              </div>

            </Scrollspy>
            
          </div>

        </div>
        <div className="main_lab_style comics">
          <section id="Safety">
            
            <div id="Comics">
              <h1>
                Comics
              </h1>
              <p>
                The SeCure comic introduces two characters, Dr. Secure, a genius scientist and his daughter, Gemma, a kid who adores his father very much and wishes to follow on his footsteps to become a scientist.
                <br />
                <br />
                <strong>
                  The comics follow the adventure and excitement of Dr. Secure with his research, while explaining bits about his research to Gemma along the way. Therefore, readers of the comic get to have fun while learning about synthetic biology, iGEM, and topics related to our team’s research, such as PCR, with Gemma along the way. These comics were also a bridge that enabled us to have a collaboration with The Chihuahua Institute of Technology from Mexico as they took interest in our comics and wanted <a href="https://drive.google.com/file/d/1Oh3Ykv7VqsJe4FyaVFcqhOU4b2JU_5Lf/view?usp=sharing">to distribute the comics</a> to elementary school students in Mexico.
                </strong>
              </p>
              <br />
              <br />
          </div>

          <div id="Characters">

            <h1 style={{ textAlign: 'center' }}>
              Characters at a glance:
            </h1>
            <br />
            <br />
            <div className="grid-container">

              <div className="title">
                <p>
                  <strong >
                    Dr. SeCure, 42 y.o.
                  </strong>
                </p>
              </div>
              <div className="col">

                <p>
                  He claims to be the God of <strong>Synthetic biology</strong>.
                  His impeccable skill for designing new biological processes lead him to <strong>3 Nobel prizes in medicine</strong>. He now uses his Genuity and his daughter's help to research and discover what mankind fears: FUNGI.
                </p>
              </div>
              <div className="col-image">
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/dr-1-1.png" alt="" />
              </div>
            </div>

            <br />
            <br />

            <div className="grid-container gemma">

              <div className="title">
                <p>
                  <strong >
                    Gemma, 12 y.o.
                  </strong>
                </p>
              </div>
              <div className="col">

                <p>
                  Daughter of <strong> Dr. SeCure</strong>. She joins her father on all his adventures of madness, learning about the unknowns of the world and synthetic biology along the way. She isn't the typical genius, but loves helping her dad with his research and hopes one day she will be as great as him.
                </p>
              </div>
              <div className="col-image">
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/gemma-1-1.png" alt="" />
              </div>
            </div>
            <br />
            <br />
            <br />
          </div>
          
            
          </section>
          <div class="slides-container">
            <div class="slides-inner">
              <div class="slide">
                <h1>What are fungi?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic1.jpeg" alt="" />
              </div>
              <div class="slide">
                <h1>What is synthetic biology?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic2.jpeg" alt="" />
              </div>
              <div class="slide">
                <h1>What is iGEM?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic3.jpeg" alt="" />
              </div>
              <div class="slide" id="Episode3">
                <h1>What is PCR?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic4.jpeg" alt="" />
              </div>
              <div class="slide">
                <h1>What is CRISPR-Cas9?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic5.jpeg" alt="" />
              </div>
              <div class="slide">
                <h1>What is our project about?</h1>
                <img src="https://static.igem.wiki/teams/4154/wiki/assets/securecomic6.jpeg" alt="" />
              </div>
            </div>
          </div>

          <div class="controls">
            <button id="prevButton">Prev page</button>
            <button id="nextButton">Next page</button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Comics;
